<template lang="pug">
    .game-container
        .side
            .item(v-if="itemsSettings.left.isShow")
                img.image(:src="getImgUrl(leftSideItems, true)")
        .center-column
        .side
            .item(v-if="itemsSettings.right.isShow")
                img.image(:src="getImgUrl(rightSideItems, false)")
</template>

<script>
    export default {
        props: {
            preparedItems: Object,
            differentFigures: Boolean,
            time: Number,
            showTime: Number,
            simultaneously: Boolean,
            viewType: String,
        },
        data() {
            return {
                itemsSettings: {
                    left: {
                        isShow: true,
                        itemIndex: 0,
                    },
                    right: {
                        isShow: true,
                        itemIndex: 0,
                    },
                },
            };
        },
        watch: {
            time(val) {
                if (val % this.showTime === 0 || (val === 1 && !this.simultaneously)) {
                    this.getSettingsForEachSides();
                    if (!this.simultaneously) {
                        this.itemsSettings.right.isShow = !this.itemsSettings.right.isShow;
                        this.itemsSettings.left.isShow = !this.itemsSettings.right.isShow;
                    }
                }
            },
        },
        computed: {
            leftSideItems() {
                return this.preparedItems.left[this.itemsSettings.left.itemIndex];
            },
            rightSideItems() {
                return this.differentFigures
                    ? this.preparedItems.right[this.itemsSettings.right.itemIndex]
                    : this.preparedItems.right[this.itemsSettings.left.itemIndex];
            },
        },
        mounted() {
            this.getSettingsForEachSides();
        },
        methods: {
            getRandomIndex() {
                const numOfItems = this.preparedItems.left.length;
                return Math.floor(Math.random() * numOfItems);
            },
            getSettingsForEachSides() {
                let prevNumber = this.itemsSettings.left.itemIndex;
                let index = this.getRandomIndex();
                this.itemsSettings.left.itemIndex = index;
                if (prevNumber === this.itemsSettings.left.itemIndex) {
                    this.getSettingsForEachSides();
                }
                while (this.itemsSettings.left.itemIndex === index) {
                    index = this.getRandomIndex();
                }
                this.itemsSettings.right.itemIndex = index;
            },
            getImgUrl(image, isLeft) {
                return isLeft
                    ? '/imgs/games/repeat-after-me/left/' + image + '.jpg'
                    : '/imgs/games/repeat-after-me/right/' + image + '.jpg';
            },
        },
    };
</script>

<style scoped lang="scss">
    .game-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 90%;
        height: 100%;
    }

    .center-column {
        border-radius: 10px;
        height: 60%;
        width: 5px;
        background-color: black;
        @include media($sm) {
            width: 7px;
        }
        @include media($md) {
            width: 9px;
        }
        @include media($lg) {
            width: 10px;
            height: 80%;
        }
    }

    .side {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
    }

    .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60%;
        height: 60%;
        font-size: 90px;
        line-height: 50px;
        @include media($sm) {
            font-size: 140px;
        }
        @include media($lg) {
            font-size: 180px;
        }
        @include media($xlg) {
            font-size: 200px;
        }
    }
</style>
